import { render } from "./PrimaryLayout.vue?vue&type=template&id=06f0d5a8&scoped=true"
import script from "./PrimaryLayout.vue?vue&type=script&lang=js"
export * from "./PrimaryLayout.vue?vue&type=script&lang=js"

import "./PrimaryLayout.vue?vue&type=style&index=0&id=06f0d5a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-06f0d5a8"

export default script